import React from 'react';
import Logo from '@/components/layout-new/Logo';
import NavLink from '@/components/layout-new/NavLink';
import Logout from '@/components/layout-new/dashboard/Logout';
import { RESUME_DASHBOARD_NAV_ID } from '@/constants/component-id';
import { CANDIDATES_ME_ROUTER_PATH } from '@/constants/router-path';

const DashboardNav = (props: {
  isSalaryLink?: boolean;
  isHideHeader?: boolean;
}) => {
  const { isSalaryLink, isHideHeader } = props;

  return (
    <nav
      id={RESUME_DASHBOARD_NAV_ID}
      className={`shrink-0 z-[1100]${isHideHeader ? ' hidden' : ''} tablet:w-[97px]`}
    >
      <div className="fixed bottom-0 bg-white w-full tablet:w-auto tablet:h-full tablet:left-0 tablet:top-0 tablet:py-6 tablet:px-2.5 tablet:border-r tablet:border-web-tertiary tablet:flex tablet:flex-col">
        <Logo
          href={CANDIDATES_ME_ROUTER_PATH}
          className="hidden tablet:flex tablet:justify-center"
        />
        <NavLink
          isSalaryLink={isSalaryLink}
          className="flex px-5 justify-between pt-3.5 pb-5 border-t tablet:flex-col tablet:mt-6.5 tablet:px-0 tablet:py-0 tablet:border-none tablet:gap-y-2.5"
        />
        <Logout />
      </div>
    </nav>
  );
};

export default DashboardNav;
